export const buildFullOrder = (workspaces, displayedNewOrderIds)=>{
    const workspaceById = new Map(workspaces.map((workspace)=>[
            workspace.id(),
            workspace
        ]));
    const displayedSet = new Set(displayedNewOrderIds);
    const remainingIds = workspaces.map((workspace)=>workspace.id()).filter((id)=>!displayedSet.has(id));
    const fullOrderIds = [
        ...displayedNewOrderIds,
        ...remainingIds
    ];
    const reorderedWorkspaces = fullOrderIds.map((id)=>workspaceById.get(id)).filter((workspace)=>workspace != null);
    return {
        fullOrderIds,
        reorderedWorkspaces
    };
};
